<section class="form-wrapper" *ngIf="pageData">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <h1 class="access">{{ pageData.title }}</h1>
      </div>
      <app-error-block *ngIf="resetError && !successfulReset">
        There was a problem resetting your password.
      </app-error-block>
      <form *ngIf="showForm; else successfulReset" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-field">
            <label for="password" class="password-label">
              {{ pageData.password_label }}
            </label>
            <input
              [formControl]="password"
              (focus)="onFocus()"
              (blur)="onBlur()"
              type="password"
              name="password"
              id="password"
              placeholder="Enter your new password"
            />
            <span
              *ngIf="password.touched && !password.value && showErrors"
              class="error"
            >
              {{ pageData.password_tooltip }}
            </span>
            <span
              *ngIf="password.touched && password.invalid && password.value"
              class="error"
            >
              {{ pageData.password_security_tooltip }}
            </span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <label for="password" class="password-label">
              {{ pageData.confirm_password_label }}
            </label>
            <input
              [formControl]="passwordConfirmation"
              (focus)="onFocus()"
              (blur)="onBlur()"
              type="password"
              name="passwordConfirmation"
              id="passwordConfirmation"
              placeholder="Re-enter your new password"
            />
            <span
              *ngIf="
                passwordConfirmation.touched &&
                !passwordConfirmation.value &&
                showErrors
              "
              class="error"
            >
              {{ pageData.confirm_password_tooltip }}
            </span>
            <span
              *ngIf="
                passwordConfirmation.touched &&
                passwordConfirmation.value &&
                passwordsNotEqual &&
                showErrors
              "
              class="error"
            >
              {{ pageData.password_match_tooltip }}
            </span>
          </div>
        </div>
        <div class="button-container">
          <button
            [class.button-loading]="
              !this.passwordsNotEqual &&
              this.password.valid &&
              passwordSubmitted
            "
            type="submit"
          >
            <span>{{ pageData.submit_button_text }}</span>
          </button>
        </div>
      </form>
      <ng-template #successfulReset>
        <app-success-block>
          {{ successMessage }}
        </app-success-block>
        <a [href]="resetPasswordRoute" class="success-button">
          <button class="btn">{{ successButtonText }}</button>
        </a>
      </ng-template>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>
</section>
